const musicLinksValidationFR = {
    "add": {
        "release_name": {
            "required": "Le nom de la sortie est requis"
        },
        "ean": {
            "required": "EAN/UPC est requis"
        },
        "artist_name": {
            "required": "Le nom de l'artiste est requis"
        },
        "url_part1": {
            "required": "La partie 1 de l'URL est requise"
        },
        "url_part2": {
            "required": "La partie 2 de l'URL est requise",
            "length": "La partie 2 de l'URL ne peut pas dépasser 10 caractères",
            "duplicate": "Oups ! Cette URL est déjà associée à un autre lien musical. Veuillez essayer une autre URL.",
            "urlAvailable": "L'URL est disponible",
            "urlInvalid": "L'URL est invalide"
        },
        "amazonmusic_url": {
            "required": "L'URL Amazon Music est requise",
            "invalid": "Veuillez ajouter une URL Amazon Music valide."
        },
        "applemusic_url": {
            "required": "L'URL Apple Music est requise",
            "invalid": "Veuillez ajouter une URL Apple Music valide."
        },
        "beatport_url": {
            "required": "L'URL Beatport est requise",
            "invalid": "Veuillez ajouter une URL Beatport valide."
        },
        "deezer_url": {
            "required": "L'URL Deezer est requise",
            "invalid": "Veuillez ajouter une URL Deezer valide."
        },
        "junodownload_url": {
            "required": "L'URL Junodownload est requise",
            "invalid": "Veuillez ajouter une URL Junodownload valide."
        },
        "soundcloud_url": {
            "required": "L'URL Soundcloud est requise",
            "invalid": "Veuillez ajouter une URL Soundcloud valide."
        },
        "spotify_url": {
            "required": "L'URL Spotify est requise",
            "invalid": "Veuillez ajouter une URL Spotify valide."
        },
        "tidal_url": {
            "required": "L'URL Tidal est requise",
            "invalid": "Veuillez ajouter une URL Tidal valide."
        },
        "traxsource_url": {
            "required": "L'URL Traxsource est requise",
            "invalid": "Veuillez ajouter une URL Traxsource valide."
        },
        "youtube_url": {
            "required": "L'URL Youtube est requise",
            "invalid": "Veuillez ajouter une URL Youtube valide."
        },
        "anghami_url": {
            "required": "L'URL Anghami est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "bandcamp_url": {
            "required": "L'URL Bandcamp est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "boomplay_url": {
            "required": "L'URL Boomplay est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "iheartradio_url": {
            "required": "L'URL iHeartRadio est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "jiosaavn_url": {
            "required": "L'URL JioSaavn est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "sevendigital_url": {
            "required": "L'URL 7digital est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "other_url": {
            "invalid": "Veuillez ajouter une URL valide."
        },
        "pvTrackName": {
            "required": "Le nom du morceau est requis"
        },
        "pvArtistName": {
            "required": "Le nom de l'artiste est requis"
        }
    },
    "update": {
        "release_name": {
            "required": "Le nom de la sortie est requis"
        },
        "ean": {
            "required": "EAN/UPC est requis"
        },
        "artist_name": {
            "required": "Le nom de l'artiste est requis"
        },
        "url_part1": {
            "required": "La partie 1 de l'URL est requise"
        },
        "url_part2": {
            "required": "La partie 2 de l'URL est requise",
            "length": "La partie 2 de l'URL ne peut pas dépasser 10 caractères",
            "duplicate": "Oups ! Cette URL est déjà associée à un autre lien musical. Veuillez essayer une autre URL.",
            "urlAvailable": "L'URL est disponible",
            "urlInvalid": "L'URL est invalide"
        },
        "amazonmusic_url": {
            "required": "L'URL Amazon Music est requise",
            "invalid": "Veuillez ajouter une URL Amazon Music valide."
        },
        "applemusic_url": {
            "required": "L'URL Apple Music est requise",
            "invalid": "Veuillez ajouter une URL Apple Music valide."
        },
        "beatport_url": {
            "required": "L'URL Beatport est requise",
            "invalid": "Veuillez ajouter une URL Beatport valide."
        },
        "deezer_url": {
            "required": "L'URL Deezer est requise",
            "invalid": "Veuillez ajouter une URL Deezer valide."
        },
        "junodownload_url": {
            "required": "L'URL Junodownload est requise",
            "invalid": "Veuillez ajouter une URL Junodownload valide."
        },
        "soundcloud_url": {
            "required": "L'URL Soundcloud est requise",
            "invalid": "Veuillez ajouter une URL Soundcloud valide."
        },
        "spotify_url": {
            "required": "L'URL Spotify est requise",
            "invalid": "Veuillez ajouter une URL Spotify valide."
        },
        "tidal_url": {
            "required": "L'URL Tidal est requise",
            "invalid": "Veuillez ajouter une URL Tidal valide."
        },
        "traxsource_url": {
            "required": "L'URL Traxsource est requise",
            "invalid": "Veuillez ajouter une URL Traxsource valide."
        },
        "youtube_url": {
            "required": "L'URL Youtube est requise",
            "invalid": "Veuillez ajouter une URL Youtube valide."
        },
        "anghami_url": {
            "required": "L'URL Anghami est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "bandcamp_url": {
            "required": "L'URL Bandcamp est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "boomplay_url": {
            "required": "L'URL Boomplay est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "iheartradio_url": {
            "required": "L'URL iHeartRadio est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "jiosaavn_url": {
            "required": "L'URL JioSaavn est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "sevendigital_url": {
            "required": "L'URL 7digital est requise",
            "invalid": "Veuillez ajouter une URL valide."
        },
        "other_url": {
            "invalid": "Veuillez ajouter une URL valide."
        },
        "pvTrackName": {
            "required": "Le nom du morceau est requis"
        },
        "pvArtistName": {
            "required": "Le nom de l'artiste est requis"
        }
    }
};

export default musicLinksValidationFR;